import { useSyncExternalStore } from "react";

import { readResearchSeen, subscribeResearchSeen } from "../researchSeen";

const unseen = () => !readResearchSeen();

/**
 * True until the attorney has opened Research once in this browser.
 * The sidebar uses this to show, then drop, the New badge.
 */
export const useResearchNew = (): boolean =>
  useSyncExternalStore(subscribeResearchSeen, unseen, unseen);
